import React from "react";
import {BrowserRouter as Router, Redirect, Route, Switch} from "react-router-dom";
import Header from "./components/Header/Header";
import ViewerPage from "./pages/Viewer/ViewerPage";
import RedirectHintPage from "./pages/RedirectHint/RedirectHintPage";
import SecondaryFooter from "./components/SecondaryFooter/SecondaryFooter";
import ErrorPage from "./pages/Error/ErrorPage";

const App = () => {
    return (
        <Router>
            <main style={{height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between"}}>
                <Header/>
                <Switch>
                    <Route exact path="/redirect-hinweis/:astorId/:pageId?" component={RedirectHintPage}/>
                    <Route exact path="/error" component={ErrorPage}/>
                    <Route
                        path="/:astorId/:pageId?"
                        render={({ match }) => (
                            <ViewerPage key={`${match.params.astorId}-${match.params.pageId}`} />
                        )}
                    />
                    <Route
                        path="/"
                        render={() => (
                            <Redirect
                                to={{
                                    pathname: "/error",
                                    state: {
                                        message: "Leider ist ein Problem aufgetreten, bitte probieren Sie es zu einem späteren Zeitpunkt wieder.",
                                        status: "500",
                                        showContact: true
                                    }
                                }}
                            />
                        )}
                    />
                </Switch>
                <SecondaryFooter/>
            </main>
        </Router>
    );
};

export default App;
